import React from 'react';

import { box, CONTENT_WIDTH, MARGIN_X, noteHeight, pt } from '../slideGeometry';

/**
 * Explanatory text under or between a page's blocks, wrapped over the lines
 * the Paginator gave it, as the .pptx draws it. A note flagged `wrap` is a
 * footnote instead: wrapped in the height the Paginator gave it and led by
 * its heading in bold when it has one.
 */
const NoteBlock = ({ block }) =>
    block.wrap ? (
        <div className="tw-text-charcoal-60" style={{ ...box(MARGIN_X, block.y, CONTENT_WIDTH, block.height), fontSize: pt(7), lineHeight: 1.2 }}>
            {block.heading && <span className="tw-font-bold">{block.heading} </span>}
            {block.text}
        </div>
    ) : (
        <div
            className="tw-italic tw-text-charcoal-60"
            style={{ ...box(MARGIN_X, block.y + 4, CONTENT_WIDTH, (block.height ?? noteHeight(block)) - 4), fontSize: pt(9) }}
        >
            {block.text}
        </div>
    );

export default NoteBlock;
